import React, { Component } from 'react';
import WholePageLoading from './WholePageLoading';

export default class ConfirmModal extends Component {
	closeModal() {
		if (!this.props.isLoading) {
			this.props.closeModal();
		}
	}

	render() {
		return (
			<div
				className={'modal ' + (this.props.isActive ? 'is-active' : '')}
			>
				<div
					className="modal-background"
					onClick={() => {
						this.closeModal();
					}}
				/>
				<div className="modal-card">
					{this.props.isLoading ? <WholePageLoading /> : null}
					<header className="modal-card-head">
						<p className="modal-card-title">{this.props.title}</p>
						<button
							className="delete"
							onClick={() => {
								this.closeModal();
							}}
						/>
					</header>
					<section className="modal-card-body">
						<div>{this.props.message}</div>
					</section>
					<footer className="modal-card-foot">
						<button
							className="button is-success"
							onClick={() => {
								this.props.onConfirm();
							}}
						>
							{this.props.okLabel ? this.props.okLabel : 'OK'}
						</button>
						<button
							className="button"
							onClick={() => {
								this.closeModal();
							}}
						>
							{this.props.cancelLabel
								? this.props.cancelLabel
								: 'Cancel'}
						</button>
					</footer>
				</div>
			</div>
		);
	}
}
